<template>
  <div>
    <Head :title="title" />
    <div class="bg-white rounded-md shadow overflow-hidden w-full p-6">
      <div class="flex justify-between items-center mb-6">
        <h2 class="text-xl font-semibold">{{ title }}</h2>
        <button v-if="canShowResignOutgoingButton && form.type_outgoing === 'leases'" type="button" class="btn-indigo" @click="resignItem(data_exit_goods.id)">Resign Outgoing</button>
      </div>
      <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
        <text-input v-model="form.date" :error="form.errors.date" type="date" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Date')" readonly />

        <select-input v-model="form.organization_id" :error="form.errors.organization_id" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('User')" :disabled="true">
          <option :value="null">{{ __('Select Customer') }}</option>
          <option v-for="s in organization" :key="s.id" :value="s.id">{{ s.name }}</option>
        </select-input>

        <select-input v-model="form.customer_id" :error="form.errors.customer_id" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Customer')" :disabled="true">
          <option :value="null">{{ __('Select User') }}</option>
          <option v-for="s in customer" :key="s.id" :value="s.id">{{ s.name }}</option>
        </select-input>

        <select-input v-model="form.type_outgoing" :required="true" :error="form.errors.type_outgoing" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Type Outgoing')" :disabled="true">
          <option :value="null">{{ __('Select Type') }}</option>
          <option v-for="s in type_outgoings" :key="s.value" :value="s.value">{{ s.name }}</option>
        </select-input>

        <textarea-input v-model="form.description" :error="form.errors.description" :rows="8" class="pb-6 w-full lg:w-1/1" placeholder="description here.." :label="__('Note')" :disabled="true"></textarea-input>

        <div class="w-full flex flex-col items-center mt-4 mb-6 pr-6 pb-8 w-full lg:w-1/1">
          <label class="form-label text-center mb-2">BTTPU Image</label>
          <div class="relative">
            <img :src="getBttpuImageUrl()" alt="BTTPU Image" class="w-32 h-32 object-cover border rounded-md shadow-sm cursor-pointer" @click="previewBttpuImage(getBttpuImageUrl())" />
            <!-- <label class="absolute inset-x-0 top-0 text-center text-white bg-black bg-opacity-50 py-1">BTTPU Image</label> -->
          </div>
        </div>

        <!-- Details Table -->
        <div class="pr-6 pb-8 w-full mt-12">
          <label class="form-label mb-6">{{ __('Details') }}:</label>
          <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="min-w-full border border-gray-300">
              <thead class="bg-gray-50">
                <tr>
                  <th class="px-4 py-2 text-left border-b border-gray-300">{{ __('No') }}</th>
                  <th class="px-4 py-2 text-left border-b border-gray-300">{{ __('Image BAST') }}</th>
                  <th class="px-4 py-2 text-left border-b border-gray-300">{{ __('Category') }}</th>
                  <th class="px-4 py-2 text-left border-b border-gray-300">{{ __('Brand') }}</th>
                  <th class="px-4 py-2 text-left border-b border-gray-300">{{ __('Type') }}</th>
                  <th class="px-4 py-2 text-left border-b border-gray-300">{{ __('Serial Number') }}</th>
                  <th class="px-4 py-2 text-left border-b border-gray-300">{{ __('User') }}</th>
                  <th class="px-4 py-2 text-left border-b border-gray-300">{{ __('Qty') }}</th>
                  <th class="px-4 py-2 text-left border-b border-gray-300">{{ __('Status') }}</th>
                  <th class="px-4 py-2 text-left border-b border-gray-300">{{ __('Asset Status') }}</th>
                  <th class="px-4 py-2 text-left border-b border-gray-300">{{ __('Action') }}</th>
                  <th class="px-4 py-2 text-left border-b border-gray-300">{{ __('BAST') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(detail, index) in form.details" :key="index" class="border-b border-gray-200">
                  <td class="px-4 py-2">{{ index + 1 }}</td>
                  <td class="px-4 py-2">
                    <img :src="getBastImageUrl(detail)" alt="BAST Image" class="w-32 h-32 object-cover border rounded-md shadow-sm cursor-pointer" @click="previewBastImage(getBastImageUrl(detail))" />
                  </td>
                  <td class="px-4 py-2">{{ detail.category }}</td>
                  <td class="px-4 py-2">{{ detail.brand }}</td>
                  <td class="px-4 py-2">{{ detail.type }}</td>
                  <td class="px-4 py-2">{{ detail.serial_number }}</td>
                  <td class="px-4 py-2">{{ detail.user }}</td>
                  <td class="px-4 py-2">{{ detail.qty }}</td>
                  <td class="px-4 py-2">
                    <span v-if="detail.resign" class="px-2 py-0.5 rounded-full text-white bg-green-500 font-bold text-xs">In</span>
                    <span v-else class="px-2 py-0.5 rounded-full text-white bg-red-500 font-bold text-xs">Out</span>
                  </td>
                  <td class="px-4 py-2">
                    <!-- Available -->
                    <span v-if="detail.status === 'available'" class="px-2 py-0.5 rounded-full bg-green-500 text-white font-bold text-xs"> Available </span>

                    <!-- Outgoing -->
                    <span v-else-if="detail.status === 'outgoing'" class="px-2 py-0.5 rounded-full bg-blue-500 text-white font-bold text-xs"> Outgoing </span>

                    <!-- Inden Part -->
                    <span v-else-if="detail.status === 'inden_part'" class="px-2 py-0.5 rounded-full bg-yellow-500 text-white font-bold text-xs"> Inden Part </span>

                    <!-- Sold -->
                    <span v-else-if="detail.status === 'sold'" class="px-2 py-0.5 rounded-full bg-red-500 text-white font-bold text-xs"> Sold </span>

                    <!-- Damaged -->
                    <span v-else-if="detail.status === 'damaged'" class="px-2 py-0.5 rounded-full bg-red-500 text-white font-bold text-xs"> Damaged </span>

                    <!-- Default (Out of Stock) -->
                    <span v-else class="px-2 py-0.5 rounded-full bg-gray-500 text-white font-bold text-xs"> Out of Stock </span>
                  </td>

                  <td v-if="user_access.outgoing_asset.update && detail.resign == false && detail.status === 'outgoing'" class="px-4 py-2">
                    <button type="button" class="btn-sm bg-green-700 text-white hover:bg-green-800 font-medium rounded-lg text-xs px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-300 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800" @click="resignDetailItem(detail.id)">Resign Item</button>
                  </td>

                  <td v-if="user_access.outgoing_asset.update && detail.resign == false && detail.status === 'outgoing'" class="px-4 py-2">
                    <button type="button" class="btn-sm bg-green-700 text-white hover:bg-green-800 font-medium rounded-lg text-xs px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-300 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800" @click="generateBast(detail.id)">Generate BAST</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Preview Modal -->
      <Modal v-if="showPreviewModal" @close="closePreviewModal" :title="modalTitle">
        <template #content>
          <img :src="bastImageUrl" alt="Preview Image" class="w-full h-full mb-4 cursor-pointer" @click="downloadBastImage" />
          <div class="flex justify-between">
            <a :href="bastImageUrl" download class="btn btn-primary">{{ __('Download') }}</a>
            <button type="button" @click="closePreviewModal()" class="btn btn-secondary ml-2">{{ __('Close') }}</button>
          </div>
        </template>
      </Modal>
    </div>
  </div>
</template>
<script>
import Layout from '@/Shared/Layout'
import { Head } from '@inertiajs/vue3'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import Modal from '@/Shared/Modal'
import { formatDate } from '@/utils/dateFormatter.js'
import TextareaInput from '@/Shared/TextareaInput'

export default {
  metaInfo() {
    return { title: this.title }
  },
  components: {
    TextInput,
    SelectInput,
    Head,
    Modal,
    TextareaInput,
  },
  layout: Layout,
  props: {
    title: String,
    data_exit_goods: Object,
    asset: Array,
    customer: Array,
    organization: Array,
    brand: Array,
    category: Array,
    type: Array,
    serial_number: Array,
    type_outgoings: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        id: this.data_exit_goods.id,
        date: formatDate(this.data_exit_goods.date, 'YYYY-MM-DD'),
        customer_id: this.data_exit_goods.customer_id,
        organization_id: this.data_exit_goods.organization_id,
        bttpu_image: this.data_exit_goods.bttpu_image,
        description: this.data_exit_goods.description,
        type_outgoing: this.data_exit_goods.type_outgoing,
        details: this.data_exit_goods.details.map((detail) => ({
          id: detail.id,
          category: detail.category,
          brand: detail.brand,
          type: detail.type,
          serial_number: detail.serial_number,
          qty: detail.qty,
          user: detail.user,
          image_bast: detail.image_bast || null,
          resign: detail.resign,
          status: detail.status,
          //   user: detail.user,
        })),
      }),
      showPreviewModal: false,
      bastImageUrl: null,
      previewType: null,
      user_access: this.$page.props.auth.user.access,
    }
  },
  computed: {
    canShowResignOutgoingButton() {
      return this.user_access.outgoing_asset.update && this.form.details.some((detail) => detail.resign == false)
    },
    modalTitle() {
      if (this.previewType === 'bast') {
        return 'BAST Image Preview'
      } else if (this.previewType === 'bttpu') {
        return 'BTTPU Image Preview'
      } else {
        return 'Image Preview'
      }
    },
  },
  methods: {
    getBastImageUrl(detail) {
      if (detail.image_bast) {
        return `/${detail.image_bast}` // Path from the server
      } else {
        return '/images/no_image.png' // Default image
      }
    },
    getBttpuImageUrl() {
      if (this.data_exit_goods.bttpu_image) {
        return `/${this.data_exit_goods.bttpu_image}` // Path from the server
      } else {
        return '/images/no_image.png' // Default image
      }
    },
    previewBastImage(image) {
      this.bastImageUrl = image
      this.showPreviewModal = true
      this.previewType = 'bast'
    },
    previewBttpuImage(image) {
      this.bastImageUrl = image
      this.showPreviewModal = true
      this.previewType = 'bttpu'
    },
    closePreviewModal() {
      this.showPreviewModal = false
      this.bastImageUrl = null
      this.previewType = null
    },
    downloadBastImage() {
      const link = document.createElement('a')
      link.href = this.bastImageUrl
      link.download = this.bastImageUrl.split('/').pop()
      link.click()
    },
    resignDetailItem(id) {
      if (confirm('Are you sure you want to resign this item?')) {
        this.$inertia.get(this.route('exit_goods.resign_detail_item', id))
      }
    },
    resignItem(id) {
      if (confirm('Are you sure you want to resign this outgoing?')) {
        this.$inertia.get(this.route('exit_goods.resign_item', id))
      }
    },
    generateBast(id) {
      window.location.href = `/dashboard/asset_management/exit_goods/bast/${id}`
    },
  },
}
</script>
